import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { customAxios } from "lib/axios";

export interface Program {
  _id: string;
  name: string;
  description?: string;
  status?: "active" | "inactive" | string;
  parentDepartmentId?: string;
  createdAt?: string;
  updatedAt?: string;
  __v?: number;
}

export type ProgramsResponse = {
  success: boolean;
  message: string;
  data: Program[];
};

const fetchProgramsByDepartment = async (
  departmentId: string
): Promise<ProgramsResponse> =>
  (await customAxios.get<ProgramsResponse>(
    `/programs/department/${departmentId}`
  )).data;

export const useGetProgramsByDepartment = (departmentId: string | null) =>
  useQuery<ProgramsResponse, AxiosError>(
    ["programs", "department", departmentId],
    () => fetchProgramsByDepartment(departmentId!),
    {
      enabled: !!departmentId,
      staleTime: 0,
      retry: 1,
      refetchOnMount: "always",
    }
  );
